"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.forgotPassword = void 0;
var http_1 = require("../../http/http");
var service_1 = __importDefault(require("../service"));
var forgotPassword = function (email) {
    return (0, http_1.create)(service_1.default.baseUrl, {
        headers: service_1.default.getDefaultHeaders(false),
    }).post('/password/forgot', {
        email: email,
    })
        .then(function (_a) {
        var data = _a.data;
        return data;
    });
};
exports.forgotPassword = forgotPassword;
exports.default = exports.forgotPassword;
